import { useQuery } from '@tanstack/react-query';

import { PostKey } from './keys';
import { PostService } from './postService';

export function useGetPosts() {
  return useQuery({
    queryKey: [PostKey.POSTS],
    queryFn: () => PostService.getPosts().then((response) => response.data),
  });
}
